import { render, staticRenderFns } from "./LibraryFolders.vue?vue&type=template&id=505e55fa&scoped=true"
import script from "./LibraryFolders.vue?vue&type=script&lang=js"
export * from "./LibraryFolders.vue?vue&type=script&lang=js"
import style0 from "./LibraryFolders.vue?vue&type=style&index=0&id=505e55fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505e55fa",
  null
  
)

export default component.exports